import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import "@/App.css";

const HomePage = lazy(() => import("@/pages/HomePage"));
const CategoryPage = lazy(() => import("@/pages/CategoryPage"));
const ContactPage = lazy(() => import("@/pages/ContactPage"));
const AboutPage = lazy(() => import("@/pages/AboutPage"));
const ExportPage = lazy(() => import("@/pages/ExportPage"));
const NotFoundPage = lazy(() => import("@/pages/NotFoundPage"));

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={null}>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/export" element={<ExportPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/whole-spices" element={<CategoryPage slug="whole-spices" />} />
            <Route path="/spice-powders" element={<CategoryPage slug="spice-powders" />} />
            <Route path="/herbs" element={<CategoryPage slug="herbs" />} />
            <Route path="/seasonings" element={<CategoryPage slug="seasonings" />} />
            <Route path="/salts" element={<CategoryPage slug="salts" />} />
            <Route path="/oils-and-extracts" element={<CategoryPage slug="oils-and-extracts" />} />
            <Route path="/ayurvedic-products" element={<CategoryPage slug="ayurvedic-products" />} />
            <Route path="/pulses" element={<CategoryPage slug="pulses" />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </Suspense>
      <Toaster position="top-right" richColors />
    </BrowserRouter>
  );
}

export default App;
